<div class="center-block">
  <div class="loader" id="loader-1"></div>
</div>